window.AirackerSearch = {
  normalize(value = '') {
    return value.normalize('NFKC').trim().replace(/\s+/g, ' ');
  },

  tokens(value = '') {
    const normalized = this.normalize(value).toLocaleLowerCase().replace(/['’]/g, '');
    return [...new Set(normalized.match(/[\p{L}\p{N}]+/gu) || [])];
  },

  buildQuery(value = '') {
    return this.tokens(value).map((token) => `title:${token}*`).join(' AND ');
  },

  displayTerm(value = '') {
    const normalized = this.normalize(value);
    if (!/title:/i.test(normalized)) return normalized;
    return [...normalized.matchAll(/title:([\p{L}\p{N}'’]+)/giu)]
      .map((match) => match[1])
      .join(' ');
  },

  buildUrl(value = '') {
    const displayTerm = this.normalize(value);
    const strictQuery = this.buildQuery(displayTerm);
    const searchUrl = `${window.Shopify?.routes?.root || '/'}search`;
    if (!strictQuery) return searchUrl;
    const parameters = new URLSearchParams({
      q: strictQuery,
      type: 'product',
      'options[prefix]': 'none',
    });
    return `${searchUrl}?${parameters.toString()}`;
  },
};

// Keep direct search links and browser-restored URLs on the same strict
// title-only rule used by every visible search form.
(() => {
  const url = new URL(window.location.href);
  const searchPath = `${window.Shopify?.routes?.root || '/'}search`.replace(/\/+$/, '');
  if (url.pathname.replace(/\/+$/, '') !== searchPath) return;

  const visibleQuery = window.AirackerSearch.normalize(url.searchParams.get('q') || '');
  if (!visibleQuery) return;

  const strictQuery = window.AirackerSearch.buildQuery(window.AirackerSearch.displayTerm(visibleQuery));
  if (!strictQuery) return;

  const shouldReplace = url.searchParams.get('q') !== strictQuery
    || url.searchParams.get('type') !== 'product'
    || url.searchParams.has('options')
    || url.searchParams.has('options[prefix]');
  if (!shouldReplace) return;

  url.searchParams.delete('options');
  url.searchParams.delete('options[prefix]');
  url.searchParams.set('q', strictQuery);
  url.searchParams.set('type', 'product');
  window.location.replace(`${url.pathname}?${url.searchParams.toString()}${url.hash}`);
})();

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.queryInput = this.querySelector('[data-airacker-search-query]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', SearchForm.prototype.onFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  onFormSubmit(event) {
    const strictQuery = window.AirackerSearch.buildQuery(this.input.value);
    if (!strictQuery) {
      event.preventDefault();
      return;
    }
    if (this.queryInput) this.queryInput.value = strictQuery;
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
